import { useTranslate } from '@refinedev/core';
import { Tag, Tooltip } from 'antd';
import {
  CheckCircleFilled,
  CloseCircleFilled,
  WarningFilled,
} from '@ant-design/icons';

interface WaiverStatusTagProps {
  waiverId: number | null;
  fingerprintValid: boolean | null;
  waivedAt?: string | null;
}

/**
 * Consent status for a withdrawal contract:
 * - no waiver linked → the customer keeps the statutory right of withdrawal
 * - waiver linked, fingerprint valid → consent verified
 * - waiver linked, fingerprint invalid → consent recorded but unverifiable
 */
export const WaiverStatusTag = ({
  waiverId,
  fingerprintValid,
  waivedAt,
}: WaiverStatusTagProps) => {
  const t = useTranslate();

  if (waiverId == null) {
    return (
      <Tag icon={<CloseCircleFilled />} color="default">
        {t('monetization.withdrawal_contracts.waiver_status.missing')}
      </Tag>
    );
  }

  const tag =
    fingerprintValid === false ? (
      <Tag icon={<WarningFilled />} color="error">
        {t('monetization.withdrawal_contracts.waiver_status.invalid')}
      </Tag>
    ) : (
      <Tag icon={<CheckCircleFilled />} color="success">
        {t('monetization.withdrawal_contracts.waiver_status.valid')}
      </Tag>
    );

  return waivedAt ? (
    <Tooltip
      title={`${t('monetization.withdrawal_contracts.fields.waived_at')}: ${new Date(waivedAt).toLocaleString()}`}
    >
      {tag}
    </Tooltip>
  ) : (
    tag
  );
};
